const de = {
  questionPaperLibrary: "Fragenpapier-Bibliothek",
  questionPaperLibraryDescription:
    "Ihr dynamischer Arbeitsbereich zum Erstellen einzelner Fragen und Entwerfen umfassender Fragenpapiere.",
  assessmentLibrary: "Bewertungsbibliothek",
  assessmentLibraryDescription:
    "Verwalten Sie Zeitplane, laden Sie Teilnehmer ein und verfolgen Sie Leistungsberichte in einem zentralen Hub.",
  myAssessmentWidgetTitle: "Meine Bewertung",
  myPreferences: "Meine Einstellungen",
  assessmentsForYou: "Bewertungen fur Sie",
  exploreAssessmentsAssignedToYou:
    "Entdecken Sie Bewertungen, die Ihnen zugewiesen wurden",
  hitachiAcademy: "Hitachi Akademie",
  essentialBusinessKnowledgeTestForYou:
    "Wesentlicher Test zum Geschaftswissen fur Sie",
  continuousLearningJourneyDescription:
    "Entwickelt, um Ihnen zu helfen, Ihre Geschaftskompetenzen auf Ihrer kontinuierlichen Lernreise zu verstehen und zu starken",
  noActiveAssessmentsScheduledForYou:
    "Keine aktiven Bewertungen fur Sie geplant",
  upcoming: "Bevorstehend",
  notAttempted: "Nicht versucht",
  myAssessmentCardDescription:
    "Diese Bewertung bewertet Ihre technischen, analytischen und Problemlosungsfahigkeiten als Teil des GlobalLogic Campus-Einstellungsprozesses.",
  totalDuration: "Gesamtdauer",
  startTime: "Startzeit",
  questionAuthoring: "Fragenerstellung",
  reviewQuestions: "Fragen uberprufen",
  bulkUploadHistory: "Massen-Upload-Verlauf",
  bulkActionHistory: "Massenaktionsverlauf",
  editQuestion: "Frage bearbeiten",
  inviteParticipants: "Teilnehmer einladen",
  externalUserBulkUploadHistory: "Massen-Upload-Verlauf externer Benutzer",
  assessmentSchedule: "Bewertungsplan",
  assessmentReport: "Bewertungsbericht",
  bulkHistory: "Massenverlauf",
  myUpload: "Mein Upload",
  bulkUpload: "Massen-Upload",
  createQuestion: "Frage erstellen",
  bulkUploadQuestions: "Fragen gesammelt hochladen",
  filters: "Filter",
  clear: "Zurucksetzen",
  searchByTitle: "Nach Titel suchen",
  refresh: "Aktualisieren",
  refreshing: "Wird aktualisiert",
  reviewQuestionPapers: "Fragenpapiere uberprufen",
  myQuestionPapers: "Meine Fragenpapiere",
  viewQuestionBank: "Fragenbank anzeigen",
  createNew: "Neu erstellen",
  sortBy: "Sortieren nach",
  state: "Status",
  reviewed: "Gepruft",
  reviewedTooltip:
    "Zeigt Fragenpapiere, die gepruft und anschliessend veroffentlicht wurden.",
  all: "Alle",
  draft: "Entwurf",
  published: "Veroffentlicht",
  inReview: "In Prufung",
  sentBack: "Zuruckgesendet",
  readyToPublish: "Bereit zur Veroffentlichung",
  draftDescription:
    "Die Erstellung des Fragenpapiers ist noch im Gange und fur Lernende noch nicht verfugbar",
  publishedDescription: "Das Fragenpapier ist live und fur Lernende zuganglich",
  inReviewDescription:
    "Das Fragenpapier wird gepruft und ist noch nicht freigegeben",
  sentBackDescription:
    "Das Fragenpapier wurde zur Uberarbeitung zuruckgesendet",
  readyToPublishDescription: "Das Fragenpapier ist zur Veroffentlichung bereit",
  createdAt: "Erstellt am",
  updatedAt: "Aktualisiert am",
  publishedAt: "Veroffentlicht am",
  descending: "Absteigend",
  ascending: "Aufsteigend",
  success: "Erfolg",
  error: "Fehler",
  warning: "Warnung",
  info: "Info",
  yes: "Ja",
  no: "Nein",
  noMatchingContentFound: "Keine passenden Inhalte gefunden",
  noQuestionPapersAvailableForReview:
    "Keine Fragenpapiere zur Prufung verfugbar",
  questionPaperNotYetCreated: "Fragenpapier wurde noch nicht erstellt",
  createQuestionPaperDescription:
    "Erstellen Sie ein Fragenpapier, um die Fahigkeiten und Kenntnisse der Lernenden zu bewerten",
  createYourFirstQuestionPaper: "Erstellen Sie Ihr erstes Fragenpapier",
  createQuestionPaperModalTitle: "Fragenpapier erstellen",
  questionsTab: "Fragen",
  questionPaperSettingsTab: "Fragenpapiereinstellungen",
  editQuestionPaper: "Fragebogen bearbeiten",
  save: "Speichern",
  publish: "Veröffentlichen",
  sendForReview: "Zur Überprüfung senden",
  sendingForReview: "Zur Überprüfung senden",
  publishing: "Veröffentlichung",
  clone: "Klon",
  delete: "Löschen",
  view: "Sicht",
  edit: "Bearbeiten",
  close: "Schließen",
  create: "Erstellen",
  creating: "Erstellen",
  confirm: "Bestätigen",
  cancel: "Stornieren",
  version: "Version",
  untitled: "Ohne Titel",
  noVersion: "Keine Version",
  title: "Titel",
  status: "Status",
  action: "Aktion",
  createdBy: "Erstellt von",
  createNewVersion: "+ Neue Version",
  createNewVersionTitle: "Neue Version erstellen",
  deleteQuestionPaperPrompt:
    "Sind Sie sicher, dass Sie dieses Fragenpapier lÃ¶schen mÃ¶chten?",
  deleteQuestionPaperWithTitlePrompt:
    "Möchten Sie diesen Fragebogen mit dem Titel „{{title}}“ löschen?",
  cloneQuestionPaperPrompt: "MÃ¶chten Sie dieses Fragenpapier klonen?",
  publishQuestionPaperPrompt:
    "Sind Sie sicher, dass Sie dieses Fragepapier verÃ¶ffentlichen mÃ¶chten?",
  sendForReviewQuestionPaperPrompt:
    "Sind Sie sicher, dass Sie dieses Fragepapier zur ÃberprÃ¼fung senden mÃ¶chten?",
  successfullyDeletedQuestionPaper:
    "Der Fragebogen wurde erfolgreich gelÃ¶scht",
  successfullyMovedQuestionPaperToDraft:
    "Das Fragenpapier wurde erfolgreich in den Entwurf verschoben",
  successfullySavedQuestionPaperData:
    "Die Fragenpapierdaten wurden erfolgreich gespeichert",
  successfullyClonedQuestionPaper: "Das Fragenpapier wurde erfolgreich geklont",
  successfullyCreatedQuestionPaper:
    "Das Fragenpapier wurde erfolgreich erstellt",
  validationFailedWithFollowingErrors:
    "Die Validierung ist mit folgenden Fehlern fehlgeschlagen:",
  failedStatusUpdateOf: "Statusaktualisierung fehlgeschlagen von:",
  savedWithFollowingWarnings: "Mit folgenden Warnungen gespeichert:",
  reviewedAndPublished: "Überprüft und veröffentlicht",
  deleting: "Löschen...",
  cloning: "Klonen...",
  assessment: "Bewertung",
  public: "Öffentlich",
  private: "Privat",
  visibility: "Sichtweite",
  questionType: "Fragetyp",
  selectQuestionTypeAndVisibility: "Wählen Sie Fragetyp und Sichtbarkeit aus",
  singleChoice: "Einzelauswahl",
  multipleChoice: "Multiple Choice",
  trueOrFalse: "Richtig oder falsch",
  fillInTheBlanks: "Lücken ausfüllen",
  codingQuestion: "Codierungsfrage",
  subjectiveQuestion: "Subjektive Frage",
  speakingQuestion: "Sprechende Frage",
  downloadTemplateEditAndReuploadQuestions:
    "Laden Sie die Vorlage herunter, bearbeiten Sie die Fragenliste und laden Sie sie erneut hoch",
  downloadExcelTemplateInstruction:
    "Laden Sie die Excel-Vorlage über die Schaltfläche unten herunter.",
  addQuestionsToSheetInstruction:
    "Fügen Sie Ihre Fragen zum Blatt hinzu (Anweisungen sind darin enthalten).",
  uploadCompletedExcelInstruction:
    "Laden Sie die fertige Excel-Datei hoch, um Fragen in großen Mengen zu importieren.",
  uploading: "Hochladen...",
  uploadQuestions: "Fragen hochladen",
  completed: "Vollendet",
  invalid: "Ungültig",
  initiated: "Initiiert",
  failed: "Fehlgeschlagen",
  fileName: "Dateiname",
  templateType: "Vorlagentyp",
  uploadedAt: "Hochgeladen unter",
  actions: "Aktionen",
  mcqTemplate: "MCQ-Vorlage",
  fibTemplate: "FIB-Vorlage",
  monitorUploadExcelDescription:
    "Ãberwachen Sie jede hochgeladene Excel-Datei, Ã¼berprÃ¼fen Sie, wie viele Fragen hinzugefÃ¼gt wurden oder fehlgeschlagen sind, und sehen Sie sich bei Bedarf Fehlerdetails an.",
  reset: "Zurücksetzen",
  showing: "Zeigt",
  to: "Zu",
  of: "von",
  results: "Ergebnisse",
  noExcelFound: "Kein Excel gefunden",
  cloneAssessmentConfirmation: "BestÃ¤tigung der Klonbewertung",
  cloneAssessmentWithTitlePrompt:
    "Sind Sie sicher, dass Sie diese Bewertung mit dem Titel â{{title}}â klonen mÃ¶chten?",
  successfullyClonedAssessment: "Bewertung erfolgreich geklont",
  newVersionContentPrompt:
    "Sie sind dabei, eine neue Version dieses Inhalts zu erstellen. Alle weiteren Ãnderungen werden in dieser Version gespeichert. MÃ¶chten Sie fortfahren?",
  createVersionWithNumber: "Erstellen (V{{version}})",
  addYourComment: "FÃ¼gen Sie Ihren Kommentar hinzu",
  maxLimitReached: "HÃ¶chstgrenze erreicht",
  deleteContentPrompt:
    "Sind Sie sicher, dass Sie diesen {{contentType}} lÃ¶schen mÃ¶chten?",
  deleteContentWithTitlePrompt:
    "Sind Sie sicher, dass Sie diesen {{contentType}} mit dem Titel â{{title}}â lÃ¶schen mÃ¶chten?",
  schedulePreview: "Zeitplanvorschau",
  reschedule: "Neu planen",
  cancelled: "Abgesagt",
  copyLink: "Link kopieren",
  assessmentIsCancelled: "Die Bewertung wird abgebrochen",
  deleteConfirmation: "BestÃ¤tigung lÃ¶schen",
  cancelConfirmation: "BestÃ¤tigung abbrechen",
  deleteAssessmentPrompt:
    "Sind Sie sicher, dass Sie diese Bewertung lÃ¶schen mÃ¶chten?",
  cancelAssessmentPrompt:
    "Sind Sie sicher, dass Sie dieses Assessment abbrechen mÃ¶chten?",
  rescheduleAssessment: "Beurteilung verschieben",
  customTermsAndConditions: "Benutzerdefinierte GeschÃ¤ftsbedingungen",
  viewTermsAndConditions: "AGB ansehen",
  scheduleNewAssessment: "Planen Sie eine neue Bewertung",
  selectQuestionPaper: "WÃ¤hlen Sie Fragebogen aus",
  createAssessment: "Bewertung erstellen",
  failedToLoadData: "Daten konnten nicht geladen werden!",
  assessmentNotYetCreated: "Bewertung noch nicht erstellt",
  createAssessmentDescription:
    "Erstellen Sie eine Bewertung, um die FÃ¤higkeiten und Kenntnisse der Lernenden zu bewerten",
  createYourFirstAssessment: "Erstellen Sie Ihre erste Bewertung",
  failedToLoadSchedules: "ZeitplÃ¤ne konnten nicht geladen werden",
  errors: "Fehler:",
  basicInformation: "Grundlegende Informationen",
  assessmentName: "Bewertungsname",
  na: "N / A",
  scheduleInstructions: "Zeitplananweisungen",
  noInstructionsProvided: "Keine Anleitung vorhanden",
  accessCriteria: "Zugriffskriterien",
  searchTags: "Such-Tags",
  viewAttributes: "Attribute anzeigen",
  termsAndConditions: "Allgemeine GeschÃ¤ftsbedingungen",
  enabled: "ErmÃ¶glicht",
  disabled: "Deaktiviert",
  requireCandidatesToAcceptTerms:
    "Fordern Sie die Kandidaten auf, die AGB zu akzeptieren, bevor sie mit der Beurteilung beginnen",
  proctoringSettings: "Ãberwachungseinstellungen",
  enableVideoProctoring: "Aktivieren Sie die VideoÃ¼berwachung",
  maximumVideoViolationsAllowed: "Maximal zulÃ¤ssige VideoverstÃ¶Ãe",
  enableBrowserProctoring: "Aktivieren Sie die BrowserÃ¼berwachung",
  maximumBrowserViolationsAllowed: "Maximal zulÃ¤ssige BrowserverstÃ¶Ãe",
  displayViolationsToCandidates: "Zeigen Sie Kandidaten VerstÃ¶Ãe an",
  actionWhenViolationLimitReached:
    "Aktion, wenn die VerstoÃgrenze erreicht ist",
  flagged: "Gekennzeichnet",
  terminate: "Beenden",
  stakeholdersAndFeedback: "Stakeholder und Feedback",
  owner: "EigentÃ¼mer",
  recruiter: "Personalvermittler",
  allowCandidateFeedback: "Erlauben Sie Kandidaten-Feedback",
  enableCandidateFeedbackDescription:
    "ErmÃ¶glichen Sie es den Kandidaten, nach Abschluss der Bewertung Feedback abzugeben",
  schedulingAndTimerSettings: "Planung und Timer-Einstellungen",
  scheduleType: "Zeitplantyp",
  loginWindow: "Anmeldefenster",
  durationBased: "Dauerbasiert",
  deadline: "Frist",
  autoCompleteMode: "AutovervollstÃ¤ndigungsmodus",
  startDateAndTime: "Startdatum und -uhrzeit",
  loginWindowInMinutes: "Anmeldefenster (in Minuten)",
  endDateAndTime: "Enddatum und -uhrzeit",
  timerEnabled: "Timer aktiviert",
  assessmentRules: "Bewertungsregeln",
  assessmentPattern: "Bewertungsmuster",
  resultVisibility: "Ergebnissichtbarkeit",
  passPercentage: "Erfolgsquote",
  maximumAttemptsAllowed: "Maximal zulÃ¤ssige Versuche",
  unlimitedAttempts: "Unbegrenzte Versuche",
  attempt: "versuchen",
  attempts: "Versuche",
  coolOffPeriodBetweenAttempts: "AbkÃ¼hlphase zwischen den Versuchen",
  questionDisplaySettings: "Einstellungen fÃ¼r die Frageanzeige",
  showQuestionTitle: "Fragentitel anzeigen",
  showQuestionTitleDescription:
    "Zeigen Sie den Fragentitel Ã¼ber jeder Frage an",
  showHint: "Hinweis anzeigen",
  hintLoading: "Sie müssen warten, bevor Sie einen weiteren Hinweis sehen",
  allHintsShown: "Es sind keine Hinweise mehr ausstehend",
  showHintDescription:
    "Aktivieren Sie Hinweise, um den Kandidaten während der Beurteilung zu unterstützen",
  showExplanation: "Erklärung anzeigen",
  hideExplanation: "Erklärung ausblenden",
  showExplanationDescription:
    "Zeigen Sie nach jeder Frageeinreichung Erklärungen an",
  showQuestionMarks: "Fragezeichen anzeigen",
  showQuestionMarksDescription:
    "Zeigen Sie den Noten-/Punktzahlwert für jede Frage an",
  showWatermark: "Wasserzeichen anzeigen",
  showWatermarkDescription:
    "Zeigen Sie die E-Mail-Adresse des Kandidaten für jede Frage als Wasserzeichen an",
  questionPaperPreview: "Vorschau des Fragebogens",
  questionPaperReview: "Überprüfung des Fragebogens",
  createSchedule: "Zeitplan erstellen",
  reviewerComments: "Kommentare des Rezensenten",
  reviewComments: "Kommentare überprüfen",
  sendBackQuestionPaperPrompt:
    "Sind Sie sicher, dass Sie diesen Fragebogen zurücksenden möchten?",
  moveQuestionPaperToDraftPrompt:
    "Sind Sie sicher, dass Sie dieses Fragepapier in den Entwurf verschieben möchten?",
  markQuestionPaperReadyToPublishPrompt:
    "Sind Sie sicher, dass Sie dieses Fragepapier als zur Veröffentlichung bereit markieren möchten?",
  questionPaperStatusUpdatedSuccessfully:
    "Fragepapierstatus erfolgreich aktualisiert!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Neue Version für Fragebogen erfolgreich erstellt!",
  questionPaperClonedSuccessfully: "Fragebogen erfolgreich geklont!",
  startAddingQuestionsPreview:
    "Fügen Sie hier Fragen hinzu, um eine Vorschau anzuzeigen",
  bulkInviteParticipants: "Masseneinladung von Teilnehmern",
  bulkInviteParticipantsDescription:
    "Laden Sie mehrere Teilnehmer gleichzeitig ein, indem Sie eine vorab ausgefüllte Excel-Datei hochladen. Bitte verwenden Sie die bereitgestellte Vorlage, um das korrekte Format sicherzustellen.",
  maxParticipantsPerFileNote:
    "Maximal 200 Teilnehmer pro Datei. Doppelte oder ungültige Einträge werden mit einem Fehler übersprungen.",
  downloadTemplate: "Vorlage herunterladen",
  creatingUser: "Benutzer erstellen...",
  bulkInviteLabel: "Masseneinladung",
  createAndInvite: "Erstellen und einladen",
  myUploads: "Meine Uploads",
  enterIndividualsForInvite:
    "Geben Sie die Namen einer oder mehrerer Personen ein, die Sie zur Beurteilung einladen möchten",
  searchPeopleByEmailOrName: "Personen nach E-Mail-Adresse oder Namen suchen",
  noResultsFound: "Keine Ergebnisse gefunden",
  loading: "Laden..",
  or: "Oder",
  multipleEmailsInviteDescription:
    "Fügen Sie mehrere Benutzer-E-Mails durch Kommas getrennt hinzu, um mehrere Benutzer zur Bewertung einzuladen",
  addCandidates: "Kandidaten hinzufügen",
  pleaseEnterValidNameOrEmail:
    "Bitte geben Sie einen gültigen Namen oder eine gültige E-Mail-Adresse ein",
  pleaseEnterValidEmailAddress:
    "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  someEmailsCouldNotBeAdded:
    "Einige E-Mail-Adressen konnten nicht hinzugefügt werden",
  checkInvalidEmailIds:
    "Bitte überprüfen Sie die folgenden E-Mail-IDs – sie scheinen ungültig zu sein:",
  failedToSendInvitesFollowingEmails:
    "Es konnten keine Einladungen an die folgenden E-Mails gesendet werden:",
  successfullyInvitedMembers: "{{count}}-Mitglied erfolgreich eingeladen",
  validationFailed: "Die Validierung ist fehlgeschlagen",
  excelUploadedSuccessfully: "Excel erfolgreich hochgeladen",
  invalidBulkNominationTemplate: "Ungültige Vorlage für Massennominierung",
  actionCompletedWithWarnings: "Aktion mit folgenden Warnungen abgeschlossen:",
  actionFailedWithErrors:
    "Die Aktion konnte mit den folgenden Fehlern nicht abgeschlossen und beendet werden:",
  trackBulkOperationsAndResults:
    "Verfolgen Sie alle Ihre Massenvorgänge und deren Ergebnisse",
  partiallySaved: "Teilweise gespeichert",
  statusInitiatedDescription:
    "Die Anfrage zur Aktualisierung der Frage wurde übermittelt und wird bearbeitet.",
  statusCompletedDescription:
    "Alle ausgewählten Fragen wurden erfolgreich aktualisiert.",
  statusFailedDescription:
    "Keine der ausgewählten Fragen konnte erfolgreich bearbeitet werden.",
  statusPartiallySavedDescription:
    "Einige Fragen wurden erfolgreich gespeichert, bei anderen traten Probleme auf.",
  draftReadyToPublishToPublish:
    "Entwurf/Bereit zur Veröffentlichung -> Veröffentlichen",
  actionType: "Aktionstyp",
  uploadedOn: "Hochgeladen am",
  viewDetails: "Details anzeigen",
  loadingRecords: "Datensätze werden geladen...",
  noRecordsFound: "Keine Datensätze gefunden",
  recordsPerPage: "Datensätze pro Seite:",
  page: "Seite",
  untitledQuestion: "Frage ohne Titel",
  globalLogic: "GlobalLogic",
  aiGenerated: "KI generiert",
  fullScreen: "Vollbild",
  exitFullScreen: "Beenden Sie den Vollbildmodus",
  skills: "Fähigkeiten",
  tags: "Schlagworte",
  allowedCodingLanguages: "Zulässige Codierungssprachen",
  marks: "Markierungen",
  lastUpdatedAt: "Zuletzt aktualisiert um",
  solutionCode: "Lösungscode",
  solution: "Lösung",
  starterCode: "Startercode",
  options: "Optionen",
  explanation: "Erläuterung",
  hint: "Hinweis",
  deleteQuestion: "Frage löschen",
  noSections: "Keine Abschnitte hinzugefügt",
  editAndPublish: "Bearbeiten und veröffentlichen",
  sendBackToDraftInstruction:
    "Klicken Sie auf die Schaltfläche „Zurücksenden“, um die Frage wieder an den Entwurf zu senden.",
  updateStatusReadyToPublishInstruction:
    "Klicken Sie auf die Schaltfläche „Bereit zur Veröffentlichung“, um den Status zu aktualisieren.",
  successfullyUpdatedStatus: "Der Status wurde erfolgreich aktualisiert",
  dismiss: "Zurückweisen",
  ongoing: "Laufend",
  toBeLaunched: "Wird gestartet",
  contentExpired: "Inhalt abgelaufen",
  notApplicable: "Nicht zutreffend",
  expiresSoon: "Läuft bald ab",
  contentCreationInProgressTooltip:
    "Die Inhaltserstellung ist noch im Gange und noch nicht für Lernende verfügbar",
  contentLiveAccessibleTooltip:
    "Der Inhalt ist live und für Lernende zugänglich",
  contentAvailableWithinDatesTooltip:
    "Der Inhalt ist derzeit verfügbar, da er innerhalb des Start- und Ablaufdatums liegt",
  contentNotLaunchedAvailableOnTooltip:
    "Der Inhalt wurde noch nicht gestartet und ist verfügbar am",
  contentExpiredOnTooltip: "Dieser Inhalt ist abgelaufen am",
  statusAvailableAfterPublishTooltip:
    "Der Status ist verfügbar, sobald der Inhalt veröffentlicht wurde",
  contentExpiresWithin48HoursTooltip:
    "Der Inhalt läuft innerhalb von 48 Stunden ab.",
  moveToDraftOrCloneToEdit:
    "Verschieben Sie es in den Entwurf oder klonen Sie es, um Bearbeitungen vorzunehmen",
  webContent: "Webinhalt",
  eLearning: "E-Learning",
  untitledContent: "Unbenannter Inhalt",
  sendToDraft: "In Entwurf verschieben",
  sendToDraftPublishedInstruction:
    'Dieser Inhalt ist bereits veröffentlicht. Klicken Sie auf die Schaltfläche "In Entwurf verschieben", um Änderungen vorzunehmen.',
  copyLinkForLearner: "Link für Lernende kopieren",
  questionPaperName: "Name des Fragenkatalogs",
  type: "Typ",
  duration: "Dauer",
  minutes: "Minuten",
  difficultyLevel: "Schwierigkeitsgrad",
  language: "Sprache",
  timezone: "Zeitzone",
  preferredLocation: "Bevorzugter Standort",
  notSelected: "Nicht ausgewählt",
  selectedPreferencesHeading: "Ausgewählte Einstellungen",
  selectedPreferencesInfo:
    "Ausgewählte Einstellungen für ein nahtloses Erlebnis",
  shortDescription: "Kurzbeschreibung",
  totalMarks: "Gesamtpunkte",
  questionPaperInstructions: "Anweisungen zum Fragenkatalog",
  expiryDate: "Ablaufdatum",
  knowledgeCategory: "Wissenskategorie",
  category: "Kategorie",
  subCategory: "Unterkategorie",
  region: "Region",
  usage: "Verwendung",
  internalUseOnly: "Nur fuer interne Nutzung",
  externalUseOnly: "Nur fuer externe Nutzung",
  availableForAll: "Fuer alle verfuegbar",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Lateinamerika",
  northAmerica: "Nordamerika",
  globalRegion: "Global",
  automotive: "Automobil",
  bankingFinancialServicesInsurance:
    "Banken, Finanzdienstleistungen und Versicherungen",
  connectivitySolutionsCommunication: "Konnektivitätslösungen/Kommunikation",
  consumerRetail: "Verbraucher & Einzelhandel",
  healthcareLifeSciences: "Gesundheitswesen & Biowissenschaften",
  manufacturingAndIndustrial: "Fertigung und Industrie",
  mediaEntertainment: "Medien & Unterhaltung",
  technology: "Technologie",
  other: "Sonstiges",
  behavioralInterpersonal: "Verhaltensbezogen/Zwischenmenschlich",
  technical: "Technisch",
  processAndTools: "Prozesse und Tools",
  polishLanguage: "Polnisch",
  spanishLanguage: "Spanisch",
  japaneseLanguage: "Japanisch",
  germanLanguage: "Deutsch",
  ukrainianLanguage: "Ukrainisch",
  swedishLanguage: "Schwedisch",
  romanianLanguage: "Rumänisch",
  slovakLanguage: "Slowakisch",
  croatianLanguage: "Kroatisch",
  englishUsLanguage: "Englisch (US)",
  englishUkLanguage: "Englisch (UK)",
  englishInLanguage: "Englisch (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Automobilstandards & Protokolle",
  businessAnalysis: "Geschäftsanalyse",
  cCpp: "C/C++",
  cloudDataScience: "Cloud-Datenwissenschaft",
  bigData: "Big Data",
  dataAnalytics: "Datenanalyse",
  databaseTech: "Datenbank",
  developmentTools: "Entwicklungstools",
  devops: "DevOps",
  embedded: "Eingebettete Systeme",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux-Kernel",
  mobileDev: "Mobile Entwicklung",
  networking: "Netzwerk",
  operatingSystemsServers: "Betriebssysteme & Server",
  otherTech: "Sonstige - Technik",
  productivityTools: "Produktivitätstools",
  programmingLangOther: "Programmiersprache - Sonstige",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Softwaretechnik",
  uxUi: "UX/UI",
  architectureTech: "Architektur",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Anforderungsmanagement/Technische Dokumentation",
  onboarding: "Onboarding",
  glTools: "GL Tools",
  processAndPolicies: "Prozesse und Richtlinien",
  communicationSubCategory: "Kommunikation",
  personalEffectiveness: "Persönliche Effektivität",
  methodologies: "Methoden",
  projectManagement: "Projektmanagement",
  peopleManagement: "Mitarbeiterführung",
  leadershipPrograms: "Führungsprogramme",
  domain: "Domäne",
  reviewer: "Prüfer",
  none: "Keine",
  questionPaperPreviewBreadcrumb: "Fragenkatalog-Vorschau: {{title}}",
  questionPaperInReviewContactReviewer:
    "Dieser Fragenkatalog befindet sich derzeit in der Prüfung. Bitte wenden Sie sich an den Prüfer.",
  randomization: "Randomisierung",
  randomizationInSectionDescription:
    "Fragen in diesem Abschnitt werden den Kandidaten in zufaelliger Reihenfolge angezeigt",
  questionPreviewPlaceholderImage: "Platzhalter für Fragenvorschau",
  createNewVersionPromptWithNumber: "Neue Version erstellen (V{{version}})?",
  questionPreviewBreadcrumb: "Fragenvorschau: {{title}}",
  questionPreviewTitle: "Fragenvorschau",
  adminView: "Admin-Ansicht",
  candidateView: "Kandidatenansicht",
  viewAsCandidate: "Als Kandidat ansehen",
  closePanel: "Panel schliessen",
  internalQuestion: "Interne Frage",
  expiresOn: "Laeuft ab am",
  expiredLabel: "Abgelaufen",
  solutionNotAdded: "Loesung nicht hinzugefuegt",
  testCases: "Testfaelle",
  testCasesNotAdded: "Testfaelle nicht hinzugefuegt",
  starterCodeNotAdded: "Starter-Code nicht hinzugefuegt",
  groupTitleLengthValidation:
    "Der Gruppentitel muss mehr als 5 und weniger als 120 Zeichen enthalten",
  addTitleHere: "Titel hier hinzufuegen...",
  groupUpdatedSuccessfully: "Gruppe erfolgreich aktualisiert",
  groupDeletedSuccessfully: "Gruppe erfolgreich geloescht",
  group: "Gruppe",
  numberOfQuestionsToBeShown: "Anzahl der anzuzeigenden Fragen",
  questionLimitPerSectionDescription:
    "Zeigen Sie den Kandidaten in den Abschnitten nur eine bestimmte Anzahl von Fragen",
  numberOfQuestionsToShow:
    "Anzahl der anzuzeigenden Fragen {{picked}}/{{total}}",
  collapseGroup: "Gruppe einklappen",
  expandGroup: "Gruppe ausklappen",
  groupSetupStartAddingQuestions:
    "Fuer diesen Abschnitt ist eine Gruppe eingerichtet. Beginnen Sie, Fragen hinzuzufuegen.",
  addMoreQuestions: "Weitere Fragen hinzufuegen",
  addQuestionFromLibrary: "Frage aus Bibliothek hinzufuegen",
  questionDeletedSuccessfully: "Frage erfolgreich geloescht",
  questionsShownCountUpdated:
    "Die Anzahl der angezeigten Fragen wurde aktualisiert",
  failedToDeleteQuestion: "Frage konnte nicht geloescht werden",
  caseSensitive: "Gross-/Kleinschreibung beachten",
  caseSensitiveDescription:
    "Wenn aktiviert, muessen Lernende die Antwort mit exakt gleicher Gross- und Kleinschreibung eingeben.",
  enterYourAnswerBelow: "Geben Sie unten Ihre Antwort ein",
  caseSensitiveAnswerInfo:
    "Diese Frage ist gross-/kleinschreibungssensitiv. Bitte geben Sie Ihre Antworten mit exakt gleicher Gross- und Kleinschreibung ein.",
  answerWithNumber: "Antwort {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com,user2@globallogic.com",
  visibleTestCases: "Sichtbare Testfaelle",
  hiddenTestCases: "Versteckte Testfaelle",
  visibleLabel: "Sichtbar",
  hiddenLabel: "Versteckt",
  responseSetting: "Antworteinstellungen",
  recordingLimit: "Aufnahme-Limit",
  minimumResponseDuration: "Minimale Antwortdauer",
  uploadLimit: "Upload-Limit",
  practiceAllowed: "Uebung erlaubt",
  standardEvaluationRubricInfo:
    "Dies ist die Standardbewertungsrubrik, die verwendet wird, um die Antwort des Kandidaten auf diese Frage zu bewerten.",
  criteria: "Kriterien",
  weightPercentage: "Gewichtung(%)",
  viewRemarks: "Bemerkungen anzeigen",
  input: "Eingabe",
  expectedOutput: "Erwartete Ausgabe",
  actualOutput: "Tatsächliche Ausgabe",
  untitledSection: "Unbenannter Abschnitt",
  testSectionDescription: "Testabschnittbeschreibung",
  groupAddedSuccessfully: "Gruppe erfolgreich hinzugefügt",
  addGroupToSection: "Gruppe zum Abschnitt hinzufügen",
  deleteSection: "Abschnitt löschen",
  questionPaperDetails: "Fragenpapieredetails",
  skillsInfoMessage:
    "Listet Sie die Schlüsselkompetenzen auf, die dieses Fragenpapier bewerten soll.",
  contentSettings: "Inhaltseinstellungen",
  stakeholderAndReview: "Stakeholder und Überprüfung",
  statusType: "Statustyp",
  notReviewed: "Nicht bewertet",
  sourceType: "Quelltyp",
  proficiency: "Kompetenz",
  beginner: "Anfänger",
  intermediate: "Dazwischenliegend",
  advanced: "Fortschrittlich",
  wecp: "WECP",
  enterMarks: "Geben Sie Noten ein",
  removeSkill: "Fertigkeit entfernen",
  searchSkills: "Suchfähigkeiten",
  noSkillsFound: "Keine Fähigkeiten gefunden.",
  enterTag: "Geben Sie einen Tag ein",
  enterOwner: "Eigentümer eingeben",
  enterReviewer: "Prüfer eingeben",
  noUserWithRole: "Kein solcher Benutzer mit dieser Rolle gefunden",
  createSection: "Abschnitt erstellen",
  untitledGroup: "Gruppe ohne Titel",
  createGroup: "Gruppe erstellen",
  collapseSections: "Abschnitte reduzieren",
  expandSections: "Erweitern Sie Abschnitte",
  assessmentNamePlaceholder: "Bitte geben Sie den Bewertungsnamen ein",
  questionPaperTitleInfo:
    "Geben Sie einen klaren, beschreibenden Titel für die Fragebögen ein.",
  shortDescriptionPlaceholder: "Geben Sie eine kurze Beschreibung an",
  shortDescriptionInfo:
    "Eine kurze Zusammenfassung, die erläutert, was in der Fragebögen behandelt wird.",
  questionPaperInstructionsInfo:
    "Schreiben Sie die Anweisungen auf, die die Kandidaten sehen werden, bevor sie mit der Fragearbeit beginnen. Fügen Sie wichtige Details wie Abschnittsregeln, Frageformate, Navigationstipps und Einreichungsrichtlinien hinzu.",
  questionPaperInstructionsPlaceholder:
    "Fügen Sie alle wichtigen Anweisungen für Lernende hinzu, bevor sie mit der Bewertung beginnen – Dauer, Bestehenskriterien, zulässige Tools oder Richtlinien.",
  totalMarksAutoCalculatedInfo:
    "Die Gesamtpunktzahl wird automatisch basierend auf der Anzahl der für jede Gruppe ausgewählten Fragen berechnet. Wenn die Anzahl der anzuzeigenden Fragen auf 0 gesetzt ist, wird diese Gruppe von der Gesamtpunktzahl ausgeschlossen.",
  questionPaperType: "Fragenpapiertyp",
  questionPaperTypeInfo: "Wählen Sie das Format des Fragebogens aus.",
  durationInfo:
    "Legen Sie die Gesamtzeit für das Ausfüllen des Fragebogens fest (in Minuten).",
  difficultyLevelInfo:
    "Wählen Sie den erwarteten Schwierigkeitsgrad basierend auf der Erfahrung des Kandidaten aus.",
  languageInfo:
    "Wählen Sie die Sprache aus, in der die Fragebögen präsentiert werden sollen.",
  tagsInfo:
    "Fügen Sie Schlüsselwörter hinzu, um anderen zu helfen, dieses Fragenpapier über eine Suche zu finden.",
  selectCategory: "Kategorie auswählen",
  createLevel: "Erstellen",
  evaluate: "Auswerten",
  analyze: "Analysieren",
  apply: "Anwenden",
  understand: "Verstehen",
  remember: "Erinnern",
  allowedCodingLanguagesRequiredInfo:
    "Das Feld ist nur erforderlich, wenn Sie dem Fragebogen Codierungsfragen hinzufügen.",
  knowledgeCategoryInfo:
    "Wählen Sie die kognitive Fähigkeitsstufe aus, auf die dieser Fragebogen abzielt, z. B. Merken, Verstehen, Anwenden.",
  allowedCodingLanguagesInfo:
    "Wählen Sie die Programmiersprachen aus, die für Codierungsfragen in diesem Fragenpapier zulässig sind.",
  expiryDateInfo:
    "Legen Sie optional ein Datum fest, nach dem dieser Fragebogen nicht mehr verwendet werden soll.",
  visibilityInfo: "Wählen Sie die Sichtbarkeit des Fragenpapiers aus",
  visibilityLockedInfo:
    "Sobald ein Fragenpapier mit öffentlicher Sichtbarkeit veröffentlicht wird, sind auch alle anderen Versionen öffentlich sichtbar. Wenn es als „Privat“ veröffentlicht wird, bleiben alle Versionen ebenfalls „Privat“.",
  reviewRequired: "Überprüfung erforderlich",
  reviewRequiredLockedInfo:
    "Die Einstellung „Überprüfung erforderlich“ wird in allen Versionen eines Fragebogens synchronisiert. Wenn eine Version mit aktivierter oder deaktivierter Überprüfung veröffentlicht wird, gilt dieselbe Einstellung für alle Versionen und kann nicht einzeln bearbeitet werden.",
  reviewRequiredInfo:
    "Aktivieren Sie diese Option, wenn dieser Fragebogen vor der Veröffentlichung einen formellen Überprüfungsprozess durchlaufen muss.",
  savingData: "Daten werden gespeichert...",
  questionDataSavedSuccessfully: "Fragendaten erfolgreich gespeichert",
  sendQuestionForReviewInstruction:
    "Klicken Sie auf die Schaltfläche „Zur Überprüfung senden“, um es an den Rezensenten zu senden und es überprüfen zu lassen!",
  publishQuestionInstruction:
    "Klicken Sie auf die Schaltfläche „Veröffentlichen“, um die Frage zu veröffentlichen.",
  noLearningContentAddedAfterSelectingYes:
    "Nach Auswahl von „Ja“ wurden keine Lerninhalte hinzugefügt",
  expectedTimeInMinutes: "Erwartete Zeit (in Min.)",
  codingMarksAutoCalculatedInfo:
    "Diese Punkte werden automatisch basierend auf den versteckten Testfällen berechnet, die dieser Frage hinzugefügt wurden",
  skillsInfoMessageQuestion:
    "Stellen Sie spezifische Fähigkeiten bereit, die die Teilnehmer durch die Frage erwerben",
  skillsSubtitleQuestion:
    "Legen Sie die mit dieser Frage verbundenen Fähigkeiten fest",
  allowedCodingLanguagesInfoQuestion:
    "Wählen Sie die zur Lösung dieser Frage verfügbaren Sprachen aus",
  selectCodingLanguages: "Wählen Sie Codierungssprachen aus",
  allLanguages: "Alle Sprachen",
  tagsInfoQuestion:
    "Geben Sie Schlüsselwörter an, um das Ereignis zu kategorisieren, zu beschreiben und zu identifizieren",
  tagsSubtitleQuestion: "Legen Sie die Tags für die Schnellsuche fest",
  knowledgeCategorySubtitleQuestion:
    "Hilft bei der Kategorisierung von Fragen nach kognitivem Fähigkeitsniveau.",
  explanationNotAvailableForSpeakingQuestion:
    "Für die Sprechfrage ist keine Erklärung verfügbar",
  ownerVersionSyncInfo:
    "Wenn wir den Besitzer dieser Version ändern, wird sie auch in allen erstellten Versionen aktualisiert.",
  ownerInfoMessage: "Wählen Sie die Haupteigentümer der Frage aus",
  ownerReviewerCannotBeSame:
    "Eigentümer und Rezensent können nicht identisch sein",
  reviewerInfoMessage:
    "Wählen Sie eine Einzelperson oder eine Gruppe von Personen als Gutachter aus.",
  stakeholdersUpdatedSuccessfully: "Stakeholder erfolgreich aktualisiert!",
  unexpectedErrorCreatingNewVersion:
    "Beim Erstellen einer neuen Version ist ein unerwarteter Fehler aufgetreten.",
  previewAndPublish: "Vorschau und Veröffentlichung",
  viewAnalytics: "Analytics anzeigen",
  cloneQuestionPrompt: "Möchten Sie diese Frage klonen?",
  evaluationRubric: "Bewertungsrubrik",
  problemStatement: "Problemstellung",
  problemStatementPlaceholder:
    "Geben Sie die Problemstellung oder die Aussage für das Quiz ein",
  addOptionsAndMarkCorrectAnswer:
    "Fügen Sie Optionen hinzu und markieren Sie die richtige Antwort",
  markCorrectAnswer: "Markieren Sie die richtige Antwort",
  addCorrectAnswer: "Richtige Antwort hinzufügen",
  enterCorrectAnswerForBlank:
    "Geben Sie die richtige Antwort für das leere Feld {{number}} ein.",
  blankWithNumber: "Leer {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Fügen Sie eine richtige Problemstellung mit einem „&Leerzeichen“ hinzu, um die Antwort zu aktivieren.",
  enterSolution: "Geben Sie die Lösung ein",
  enterExplanation: "Geben Sie die Erklärung ein",
  codingSolutionExplanationPlaceholder:
    "Erklären Sie kurz die Logik, den Ansatz und die Randfälle, die in der optimalen Lösung behandelt werden",
  optionWithNumber: "Option {{number}}",
  enterExplanationForAnswer:
    "Geben Sie die Erklärung für die Antwort {{number}} ein.",
  addOptionToEnableExplanation:
    "Fügen Sie die Option {{number}} hinzu, um die Erklärung zu aktivieren.",
  enterExplanationForBlank:
    "Geben Sie die Erklärung für Leerzeichen {{number}} ein.",
  addProblemStatementWithBlankToEnableExplanation:
    "Fügen Sie eine korrekte Problemerklärung mit einem „&Leerzeichen“ hinzu, um die Erklärung zu ermöglichen.",
  enterHint: "Geben Sie den Hinweis ein",
  addUpTo3Hints: "Fügen Sie bis zu 3 Hinweise hinzu",
  addMoreOptions: "Fügen Sie weitere Optionen hinzu",
  answer: "Antwort",
  exitCodeBlockInfo:
    "Um den Codeblock zu verlassen, gehen Sie zum Ende der Zeile und klicken Sie dreimal auf „Enter“.",
  fibBlankInsertionInfo:
    "Um ein Leerzeichen hinzuzufügen, wählen Sie Text aus und klicken Sie auf die Schaltfläche „Leerzeichen einfügen“ oder fügen Sie manuell &blankN hinzu, wobei N eine beliebige ganze Zahl sein kann, z. B.: &blank1;",
  htmlEditorAccessInfo:
    "Um Code hinzuzufügen oder das Format zu steuern, können Sie auf den HTML-Editor zugreifen, indem Sie auf das Bearbeitungssymbol klicken",
  skillSelectionCannotBeEmpty: "Die Fähigkeitsauswahl darf nicht leer sein",
  maxDurationInfo:
    "Maximale Zeit, die einem Benutzer zum Aufzeichnen seiner Antwort auf diese Frage gewährt wird.",
  minDurationInfo:
    "Erforderliche Mindestaufzeichnungszeit, die ein Benutzer absolvieren muss, bevor er seine Antwort absendet.",
  uploadLimitInfo:
    "Gibt an, wie oft ein Benutzer seine Antwort vor der endgültigen Übermittlung erneut aufzeichnen kann.",
  textQuestionTitle: "Dies ist eine Textfrage",
  audioRecordQuestionTitle: "Dies ist eine Audioaufnahme-Frage",
  audioUploadQuestionTitle: "Dies ist eine Frage zum Hochladen von Audiodaten",
  videoRecordQuestionTitle: "Dies ist eine Frage zur Videoaufnahme",
  videoUploadQuestionTitle: "Dies ist eine Frage zum Hochladen von Videos",
  subjectiveQuestionUploadConfigTitle:
    "Subjektiver Frage-Upload-Konfigurationstitel",
  recordingLimitInMinutes: "Aufnahmelimit (in Min.)",
  minimumResponseDurationInMinutes: "Mindestantwortdauer (in Min.)",
  recordingLimitLessThanTwenty: "Das Aufnahmelimit muss unter 20 liegen",
  recordingLimitGreaterThanOrEqualOne:
    "Das Aufzeichnungslimit muss größer oder gleich 1 sein",
  minimumDurationLessThanRecordingLimit:
    "Die Mindestantwortdauer muss unter dem Aufzeichnungslimit liegen",
  durationGreaterThanPointFive: "Die Dauer muss größer als 0,5 sein",
  uploadLimitGreaterThanZero: "Das Upload-Limit muss größer als 0 sein",
  addFieldSelectCodingLanguagesInfo:
    "Um ein {{fieldLabel}} hinzuzufügen, wählen Sie bitte zunächst im Abschnitt „{{basicDetails}}“ die zulässigen Codierungssprachen aus.",
  basicDetails: "Grundlegende Details",
  loadingEditor: "Editor wird geladen...",
  run: "Ausführen",
  writingSolutionInLanguage: "Sie schreiben gerade an einer Lösung",
  changingToLanguageWillClearInput: "Wechseln zu",
  unsavedChangesWillBeLostInLanguage: "Ihre nicht gespeicherten Änderungen in",
  changeLanguage: "Sprache ändern",
  testCase: "Testfall",
  add: "Hinzufügen",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Fügen Sie unten mindestens 2 sichtbare Testfälle und 3 versteckte Testfälle hinzu",
  visibleToCandidatesForSelfEvaluation:
    "Sichtbar für Kandidaten zur Selbsteinschätzung",
  noVisibleTestCasesAddedYet:
    "Es wurden noch keine sichtbaren Testfälle hinzugefügt. Klicken Sie auf die Schaltfläche unten, um eine hinzuzufügen.",
  visibleTestCasesCannotExceedTwenty:
    "Es dürfen nicht mehr als 20 sichtbare Testfälle vorhanden sein",
  addMoreVisibleTestCases: "Fügen Sie weitere sichtbare Testfälle hinzu",
  maximumTestCasesLimitReached: "Maximale Testfallgrenze erreicht",
  hiddenToCandidatesRunsAfterSubmit:
    "Für Kandidaten verborgen, wird ausgeführt, nachdem der Kandidat eingereicht hat",
  noHiddenTestCasesAddedYet:
    "Es wurden noch keine versteckten Testfälle hinzugefügt. Klicken Sie auf die Schaltfläche unten, um eine hinzuzufügen.",
  hiddenTestCasesCannotExceedTen:
    "Es darf nicht mehr als 10 versteckte Testfälle geben",
  addMoreHiddenTestCases: "Fügen Sie weitere versteckte Testfälle hinzu",
  hiddenTestCase: "Versteckter Testfall",
  visibleTestCase: "Sichtbarer Testfall",
  someQuestionsCouldNotBeUpdated:
    "Einige Fragen konnten nicht aktualisiert werden. Bitte überprüfen Sie die Fragen und versuchen Sie es erneut.",
  publishSummary: "Zusammenfassung veröffentlichen",
  sendForReviewSummary: "Zur Zusammenfassung der Bewertung senden",
  moveToDraftSummary: "Gehen Sie zur Entwurfszusammenfassung",
  actionSummary: "Aktionszusammenfassung",
  publishSummarySubtitle:
    "Hier ist die Zusammenfassung Ihrer Veröffentlichungsaktion. Sehen Sie sich die Details unten an.",
  sendForReviewSummarySubtitle:
    "Hier ist die Zusammenfassung Ihrer Bewertungsanfrage. Sehen Sie sich die Details unten an.",
  moveToDraftSummarySubtitle:
    "Hier ist die Zusammenfassung Ihres Übergangs zum Aktionsentwurf. Sehen Sie sich die Details unten an.",
  actionSummarySubtitle:
    "Hier ist die Zusammenfassung Ihrer Aktion. Sehen Sie sich die Details unten an.",
  successfully: "Erfolgreich",
  failedTo: "Gescheitert",
  moveToDraft: "Zum Entwurf wechseln",
  details: "Einzelheiten",
  questionTitle: "Titel der Frage",
  reason: "Grund",
  showLess: "Weniger anzeigen",
  showMoreCount: "{{count}} mehr anzeigen",
  uploadedAllCountItems: "Alle {{count}} {{item}} hochgeladen",
  partiallyUploadedCountItems:
    "Teilweise hochgeladen {{successCount}}/{{totalCount}} {{item}}",
  users: "Benutzer",
  questions: "Fragen",
  viewErrors: "Fehler anzeigen",
  errorsWithFileName: "Fehler – {{fileName}}",
  inputIsRequired: "Eine Eingabe ist erforderlich",
  expectedOutputIsRequired: "Erwartete Ausgabe ist erforderlich",
  expectedOutputCannotBeBlank:
    "Die erwartete Ausgabe darf nicht leer oder nur Leerzeichen sein",
  marksMustBeNumber: "Markierungen sollten eine Zahl sein",
  marksAreRequired: "Noten sind erforderlich",
  hiddenTestCaseMarksGreaterThanZero:
    "Um fortzufahren, müssen die Markierungen für ausgeblendete Testfälle größer als 0 sein.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Die Punktzahl für versteckte Testfälle sollte 30.000 nicht überschreiten.",
  explanationMinFiveIfProvided:
    "Falls angegeben, muss die Erläuterung mindestens 5 Zeichen lang sein",
  explanationIsRequired: "Erklärung ist erforderlich",
  explanationMinFiveNotBlank:
    "Die Erklärung muss mindestens 5 Zeichen lang sein und darf nicht nur Leerzeichen enthalten",
  provideInput: "Geben Sie Input",
  provideExpectedOutput: "Geben Sie die erwartete Ausgabe an",
  enterScore: "Geben Sie den Punktestand ein",
  optional: "optional",
  explainTestCase: "Erklären Sie den Testfall",
  updateTestCase: "Testfall aktualisieren",
  addTestCase: "Testfall hinzufügen",
  deleteQuestionWithTitlePrompt:
    "Sind Sie sicher, dass Sie diese Frage mit dem Titel '{{title}}' löschen möchten?",
  errorFetchingData: "Fehler beim Abrufen der Daten",
  rowNumber: "Zeilennummer",
  columnName: "Spaltenname",
  useCase: "Anwendungsfall",
  startsAt: "Beginnt um",
  endsAt: "Endet um",
  invite: "Einladen",
  viewReport: "Bericht anzeigen",
  successfullyDeletedAssessment: "Die Bewertung wurde erfolgreich gelöscht",
  successfullyFreezeActionAssessment:
    "{{action}} die Bewertung erfolgreich abgeschlossen",
  freezeOperationFailed: "Einfriervorgang fehlgeschlagen",
  deleteAssessmentWithTitlePrompt:
    "Sind Sie sicher, dass Sie diese Bewertung mit dem Titel „{{title}}“ löschen möchten?",
  freeze: "Einfrieren",
  unfreeze: "Auftauen",
  freezeAssessmentPrompt:
    "Sind Sie sicher, dass Sie diese Bewertung {{action}} möchten?",
  expiresAt: "Läuft ab um",
  seePreview: "Siehe Vorschau",
  schedule: "Zeitplan",
  skillBenchmarking: "Kompetenz-Benchmarking",
  skillBenchmarkingOverview:
    "Ein Überblick über die Kenntnisse der Teilnehmer in bestimmten Fertigkeiten.",
  proctoringAnalysis: "Überwachungsanalyse",
  proctoringAnalysisOverview:
    "Ein kurzer Überblick über die überwachungsbezogenen Aspekte der Bewertung.",
  proctoringStatus: "Überwachungsstatus",
  noIrregularitiesReported: "Es wurden keine Unregelmäßigkeiten gemeldet.",
  monitoringOverview: "Überwachungsübersicht",
  complianceNoIncidents:
    "Einhaltung der Bewertungsregeln; Keine Vorfälle oder auffälligen Verhaltensweisen.",
  viewEvidenceClicked: "Angeklickter Beweis!",
  marksObtained: "Punkte erhalten",
  correctAnswer: "Richtige Antwort",
  wrongAnswer: "Falsche Antwort",
  sectionWiseAnalysis: "Abschnittsweise Analyse",
  sectionWiseAnalysisOverview:
    "Eine Übersicht über jede Frage und die Antwort des Kandidaten.",
  openAllSections: "Öffnen Sie alle Abschnitte",
  closeAllSections: "Schließen Sie alle Abschnitte",
  sectionWithNumber: "Abschnitt {{number}}:",
  score: "Punktzahl",
  questionAnalysis: "Fragenanalyse",
  questionTitleFallback: "Titel der Frage",
  candidateAnswer: "Antwort des Kandidaten",
  loadAllQuestions: "Alle laden {{count}} {{item}}",
  attemptWithNumber: "Versuch #{{number}}",
  invalidReportUrl: "Ungültige Berichts-URL",
  failedToDownloadReportTryAgainLater:
    "Der Bericht konnte nicht heruntergeladen werden. Bitte versuchen Sie es später noch einmal!",
  downloadReport: "Bericht herunterladen",
  participantName: "Name des Teilnehmers",
  dateOfAttempt: "Datum des Versuchs",
  fail: "Scheitern",
  pass: "Passieren",
  userScoredInAssessment: "{{name}} erzielte in der Bewertung {{percentage}}.",
  overallSummary: "Gesamtzusammenfassung",
  sectionAnalytics: "Abschnitt Analytics",
  allAttempts: "Alle Versuche",
  bestAttempt: "Bester Versuch",
  latestAttempt: "Letzter Versuch",
  participantList: "Teilnehmerliste",
  totalParticipantsInvited: "Gesamtzahl der eingeladenen Teilnehmer",
  notStarted: "Nicht gestartet",
  inProgress: "Im Gange",
  resultsInProgress: "Ergebnisse in Bearbeitung",
  searchByNameOrEmail: "Suchen Sie nach Name oder E-Mail",
  noUsersAvailableReportCannotBeGenerated:
    "Keine Benutzer verfügbar – Bericht kann nicht erstellt werden.",
  userName: "Benutzername",
  totalAttempt: "Totaler Versuch",
  percentage: "Prozentsatz(%)",
  attemptTimeline: "Zeitleiste des Versuchs",
  noDataFound: "Keine Daten gefunden",
  outOfMarks: "{{obtained}} von {{max}} Punkten",
  resultInProcess: "Ergebnis in Bearbeitung",
  participantNotFound: "Teilnehmer nicht gefunden!",
  searchedParticipantNotFound: "Gesuchter Teilnehmer nicht gefunden!",
  noParticipantEnrolled: "Kein Teilnehmer eingeschrieben!",
  noDataToDisplay: "Keine Daten zum Anzeigen",
  participantsPerPage: "Teilnehmer pro Seite:",
  actionFailed: "Aktion fehlgeschlagen",
  failedToRemoveUser: "Benutzer konnte nicht entfernt werden",
  bestScoreAcrossAttemptsInfo:
    "Gibt die beste Punktzahl an, die über mehrere Versuche hinweg erreicht wurde.",
  successfullyRemovedUser: "Der Benutzer wurde erfolgreich entfernt",
  successfullyReinvitedUser: "Der Benutzer wurde erfolgreich erneut eingeladen",
  reinviteTooltip:
    "Laden Sie Teilnehmer erneut ein, die noch nicht mit der laufenden Bewertung begonnen haben",
  reInvite: "Erneut einladen",
  noParticipantsInvitedYet: "Es wurden noch keine Teilnehmer eingeladen",
  scheduleExpired: "Zeitplan abgelaufen",
  assessmentIsOngoing: "Die Bewertung ist noch nicht abgeschlossen",
  assessmentCompleted: "Bewertung abgeschlossen",
  resultNotProcessed: "Ergebnis nicht verarbeitet",
  assessmentNotStarted: "Die Bewertung wurde nicht gestartet",
  remove: "Entfernen",
  confirmReInvitation: "Bestätigen Sie die erneute Einladung",
  confirmReinviteMessage:
    "Sind Sie sicher, dass Sie Teilnehmer erneut einladen möchten, die noch nicht mit der laufenden Bewertung begonnen haben?",
  removeUserWithNamePrompt:
    "Sind Sie sicher, dass Sie „{{name}}“ entfernen möchten?",
  groupType: "Gruppentyp",
  objectiveGroupType: "Objektiv",
  codingGroupType: "Codierung",
  subjectiveTextSpeakingGroupType: "Subjektiv (Text / Sprechen)",
  groupTypeImmutableInfo:
    "Der Gruppentyp kann später nicht geändert werden. Es können nur Fragen dieses Typs hinzugefügt werden.",
  sameMarkGroupingTitle:
    "Fragen können nur gruppiert werden, wenn sie den gleichen Notenwert haben",
  sameMarkGroupingDescription:
    "Das Mischen von Notenwerten (z. B. 2 Punkte und 5 Punkte) in einer Gruppe kann zu unterschiedlichen Abschnittsergebnissen führen, wenn nur einige Fragen ausgewählt werden. Gruppieren Sie Fragen mit ähnlichen Noten, um die Ergebnisse konsistent zu halten.",
  searchQuestion: "Suchfrage",
  addAllSelectedQuestions: "Alle {{count}} ausgewählten Fragen hinzufügen",
  singleQuestionSelectedCount: "{{count}} Frage ausgewählt",
  allQuestionsSelectedCount: "Alle {{count}} Fragen ausgewählt",
  selectedCountOfTotalQuestions:
    "{{selected}} von {{total}} {{label}} ausgewählt",
  addSelectedQuestion: "Fügen Sie die ausgewählte Frage hinzu",
  validationErrors: "Validierungsfehler",
  failedToAddToGroup: "Hinzufügen zur Gruppe fehlgeschlagen",
  questionsAddedSuccessfullyWithCount:
    "{{count}} Fragen erfolgreich hinzugefügt",
  successfullyUpdatedAssessment: "Bewertung erfolgreich aktualisiert",
  editCustomTnc: "Benutzerdefinierte Nutzungsbedingungen bearbeiten",
  addCustomTnc: "Benutzerdefinierte Nutzungsbedingungen hinzufügen",
  attributes: "Attribute",
  added: "Hinzugefügt",
  addAttributes: "Attribute hinzufügen",
  clickHereToAddEditAttributes:
    "Hier klicken, um Attribute hinzuzufügen/zu bearbeiten",
  clickHereToAddAttributes: "Hier klicken, um Attribute hinzuzufügen",
  addTncAndSave: "Nutzungsbedingungen hinzufügen und speichern",
  savedWithFollowingErrors: "Mit folgenden Fehlern gespeichert",
  selectDomain: "Bereich auswählen",
  selectRegion: "Region auswählen",
  selectUsage: "Verwendung auswählen",
  selectCategoryFirst: "Zuerst Kategorie auswählen",
  selectSubCategory: "Unterkategorie auswählen",
  addAttributesAndSave: "Attribute hinzufügen und speichern",
  questionPaperTimer: "Timer für Fragebogen",
  sectionLevelTimer: "Timer auf Abschnittsebene",
  questionLevelTimer: "Timer auf Frageebene",
  loginWindowDescription:
    "Kandidaten können dem Test nur innerhalb eines begrenzten Zeitfensters nach der Startzeit beitreten.",
  durationBasedDescription:
    "Die Endzeit wird automatisch aus Startzeit + Testdauer berechnet.",
  deadlineDescription:
    "Feste Start- und Endzeit; Kandidaten müssen vor Ablauf der Frist fertig sein.",
  loginWindowInfo:
    "Das Anmeldefenster ist die Zeit (in Minuten), in der Kandidaten nach der geplanten Startzeit mit der Bewertung beginnen können. Sobald das Anmeldefenster schließt, kann kein neuer Kandidat mehr beitreten. Das Anmeldefenster muss kleiner oder gleich der Dauer der Prüfung sein.",
  assessmentDurationInfo:
    "Legen Sie nur die Startzeit fest. Das System berechnet die Endzeit automatisch, indem es die Testdauer addiert.",
  startTimeMinAheadInfo:
    "Die Startzeit muss mindestens 15 Minuten in der Zukunft liegen.",
  loginWindowExample:
    "Beispiel: Wenn die Startzeit um 9:00 Uhr ist und das Anmeldefenster 30 Minuten beträgt, können Kandidaten zwischen 9:00 und 9:30 Uhr mit einem zusätzlichen Puffer von 5 Minuten beginnen.",
  assessmentDurationExample:
    "Beispiel: Wenn die Startzeit um 9:00 Uhr ist und die Testdauer 60 Minuten beträgt, endet die Bewertung um 10:00 Uhr mit einem zusätzlichen Puffer von 5 Minuten.",
  freeFlow: "Freier Durchlauf",
  oneByOne: "Nacheinander",
  subjectiveNoResultInfo: "Subjektive Info zu 'Kein Ergebnis'",
  candidateResultVisibility: "Sichtbarkeit der Ergebnisse für Kandidaten",
  noResult: "Kein Ergebnis",
  passPercentageRangeError: "Fehler im Bereich der Mindestbestehensquote",
  attemptsAllowedInfo: "Info zu erlaubten Versuchen",
  maxAttemptsError: "Fehler: Maximale Anzahl an Versuchen überschritten",
  maximumAttemptsInfo: "Info zu maximalen Versuchen",
  limitedAttempts: "Begrenzte Versuche",
  coolOffDescription: "Beschreibung der Wartezeit",
  noCoolOffPeriod: "Keine Wartezeit",
  waitFor: "Warten auf",
  hours: "Stunden",
  days: "Tage",
  whatLearnersWillSee: "Was Lernende sehen werden",
  unlimitedAttemptsInfo:
    "Für diese Bewertung steht Ihnen eine unbegrenzte Anzahl von Versuchen zur Verfügung.",
  waitBeforeNextAttemptPrefix: "Nach jedem Versuch müssen Sie warten",
  waitBeforeNextAttemptSuffix:
    "bevor Sie Ihren nächsten Versuch starten können.",
  waitBeforeNextAttempt:
    "Nach jedem Versuch müssen Sie {duration} warten, bevor Sie Ihren nächsten Versuch starten können.",
  singleAttemptInfo: "Für diese Bewertung steht Ihnen 1 Versuch zur Verfügung.",
  remainingAttemptsInfoPrefix: "Sie haben",
  remainingAttemptsInfoMiddle: "von",
  remainingAttemptsInfoSuffix: "Versuchen für diese Bewertung verfügbar.",
  remainingAttemptsInfo:
    "Sie haben {remaining} von {total} Versuchen für diese Bewertung verfügbar.",
  enableCertificate: "Zertifikat aktivieren",
  enableCertificateDescription:
    "Stellen Sie Kandidaten bei erfolgreichem Abschluss der Bewertung ein Zertifikat aus.",
  maxAllowed100: "Maximal 100 erlaubt",
  scheduleAssessment: "Bewertung planen",
  privateAssessmentLabel: "Private Bewertung",
  publicAssessmentLabel: "Offentliche Bewertung",
  privateAssessmentDescription:
    "Diese Bewertung ist nur per Einladung zuganglich und nur innerhalb des festgelegten Start- und Endzeitfensters verfugbar.",
  publicAssessmentDescription:
    "Diese Bewertung unterstutzt sowohl selbststandigen als auch einladungsbasierten Zugriff, ohne festes Zugriffszeitfenster.",
  schedulePublicAssessment: "Öffentliche Bewertung planen",
  successfullyPublishedAssessment: "Bewertung erfolgreich veröffentlicht",
  publishWithoutProctoringPrompt: "Ohne Prüfungsüberwachung veröffentlichen?",
  publishAssessmentPrompt: "Bewertung veröffentlichen?",
  sectionScoreAnalysis: "Analyse der Abschnittsbewertung",
  sectionScoreAnalysisOverview: "Übersicht der Analyse der Abschnittsbewertung",
  section: "Abschnitt",
  noSectionDataAvailable: "Keine Abschnittsdaten verfügbar",
  difficultyLevelAnalysis: "Analyse des Schwierigkeitsgrads",
  browserViolations: "Browser-Verstöße",
  videoViolations: "Video-Verstöße",
  times: "Mal",
  statusMessageUnavailable: "Statusmeldung nicht verfügbar",
  viewViolationEvidence: "Nachweis des Verstoßes anzeigen",
  noBrowserViolationsDetected: "Keine Browser-Verstöße erkannt",
  noVideoViolationsDetected: "Keine Video-Verstöße erkannt",
  candidateNotAttemptedCodingMessage:
    "Nachricht: Kandidat hat die Programmieraufgabe nicht versucht",
  candidateCode: "Kandidatencode",
  candidateScore: "Kandidatenpunktzahl",
  compilationCount: "Anzahl der Kompilierungen",
  submissionCount: "Anzahl der Abgaben",
  timeTaken: "Benötigte Zeit",
  testCaseReport: "Testfall-Bericht",
  performanceAndCompilationMetrics: "Leistungs- und Kompilierungsmetriken",
  totalTestCases: "Testfälle gesamt",
  testCasesPassed: "Bestandene Testfälle",
  testCaseDetails: "Testfalldetails",
  searchQuestions: "Fragen suchen",
  clearSearch: "Suche löschen",
  question: "Frage",
  isSelected: "ist ausgewählt",
  areSelected: "sind ausgewählt",
  selected: "Ausgewählt",
  questionsPerPage: "Fragen pro Seite:",
  publishQuestions: "Fragen veröffentlichen",
  send: "Senden",
  move: "Verschieben",
  publishQuestionsConfirmation:
    "Sind Sie sicher, dass Sie {{count}} {{label}} veröffentlichen möchten?",
  sendForReviewConfirmation:
    "Sind Sie sicher, dass Sie {{count}} {{label}} zur Überprüfung senden möchten?",
  moveToDraftConfirmation:
    "Sind Sie sicher, dass Sie {{count}} {{label}} in den Entwurf verschieben möchten?",
  bulkPublishDisclaimer:
    "Bitte überprüfen Sie vor dem Veröffentlichen, ob alle ausgewählten Fragen vollständig und korrekt sind und wie gewünscht angezeigt werden.",
  bulkReviewDisclaimer:
    "Bitte überprüfen Sie vor dem Senden zur Überprüfung, ob alle ausgewählten Fragen vollständig und korrekt sind und wie gewünscht angezeigt werden.",
  bulkDraftDisclaimer:
    "Bitte überprüfen Sie vor dem Verschieben in den Entwurf, ob alle ausgewählten Fragen vollständig und korrekt sind und wie gewünscht angezeigt werden.",
  questionsUnderProcess:
    "Die Fragen werden bearbeitet. Bitte klicken Sie auf 'Details anzeigen', um den Status der Fragen zu überprüfen.",
  mixedStatusesSelected: "Gemischte Status ausgewählt",
  mixedStatusesWarning:
    "Bitte stellen Sie sicher, dass alle ausgewählten Fragen denselben Status haben, bevor Sie fortfahren.",
  selectionLimitReached: "Auswahllimit erreicht",
  selectionLimitWarning:
    "Sie können nicht mehr als {{count}} Fragen für eine Massenaktion auswählen. Desaktivieren Sie die Auswahl einer Frage, bevor Sie eine andere auswählen.",
  knowMore: "Mehr erfahren",
  guideLearnersRightDepth:
    "Leiten Sie Ihre Lernenden mit Fragen, die zur richtigen Tiefe passen.",
  bloomCreateDescription:
    "Bewerten Sie die Fähigkeit des Lernenden, neue Systeme oder Codelösungen unter Verwendung mehrerer Konzepte zu entwerfen, zuarchitektieren oder zu bauen.",
  bloomEvaluateDescription:
    "Überprüfen Sie, ob der Lernende Code kritisch beurteilen, Entscheidungen rechtfertigen oder verschiedene Lösungen evaluieren kann.",
  bloomAnalyzeDescription:
    "Testen Sie die Fähigkeit des Lernenden, Code zu zerlegen, zu debuggen, die Logik nachzuverfolgen oder Muster in technischen Systemen zu identifizieren.",
  bloomApplyDescription:
    "Evaluieren Sie, ob der Lernende Konzepte anwenden kann, um praktische Codierungsprobleme oder reale Szenarien zu lösen.",
  bloomUnderstandDescription:
    "Überprüfen Sie, ob der Lernende Konzepte in eigenen Worten verstehen und erklären oder Verhalten interpretieren kann.",
  bloomRememberDescription:
    "Bewerten Sie die Fähigkeit des Lernenden, grundlegende Definitionen, Syntax und Faktenwissen abzurufen.",
  bloomVerbCreate: "Erstellen",
  bloomVerbDesign: "Entwerfen",
  bloomVerbConstruct: "Konstruieren",
  bloomVerbDevelop: "Entwickeln",
  bloomVerbEvaluate: "Evaluieren",
  bloomVerbJustify: "Rechtfertigen",
  bloomVerbDefend: "Verteidigen",
  bloomVerbAssess: "Beurteilen",
  bloomVerbAnalyze: "Analysieren",
  bloomVerbDifferentiate: "Differenzieren",
  bloomVerbOrganize: "Organisieren",
  bloomVerbCompare: "Vergleichen",
  bloomVerbApply: "Anwenden",
  bloomVerbUse: "Verwenden",
  bloomVerbDemonstrate: "Demonstrieren",
  bloomVerbSolve: "Lösen",
  bloomVerbExplain: "Erklären",
  bloomVerbDescribe: "Beschreiben",
  bloomVerbSummarize: "Zusammenfassen",
  bloomVerbInterpret: "Interpretieren",
  bloomVerbList: "Auflisten",
  bloomVerbDefine: "Definieren",
  bloomVerbName: "Nennen",
  bloomVerbRecall: "Abrufen",
  bloomVerbRecognize: "Erkennen",
  bloomCreateExample1:
    "Erstellen Sie eine Single-Page-Anwendung mit React und Redux.",
  bloomCreateExample2:
    "Entwerfen Sie ein Schema für die Datenbank einer Ride-Sharing-App.",
  bloomCreateExample3: "Entwickeln Sie eine CI/CD-Pipeline mit GitHub Actions.",
  bloomEvaluateExample1:
    "Evaluieren Sie die Vor- und Nachteile der Verwendung von NoSQL gegenüber SQL in einer Microservices-Architektur.",
  bloomEvaluateExample2:
    "Empfehlen Sie Verbesserungen, um die Leistung der React-Komponente zu optimieren.",
  bloomAnalyzeExample1:
    "Vergleichen Sie die Leistung von Merge Sort und Quicksort.",
  bloomAnalyzeExample2:
    "Analysieren Sie die Speichernutzung dieser rekursiven Funktion.",
  bloomAnalyzeExample3:
    "Kategorisieren Sie die Fehler in diesem JavaScript-Codeblock.",
  bloomApplyExample1:
    "Wenden Sie den binären Suchalgorithmus an, um ein Element in einem Array zu finden.",
  bloomApplyExample2:
    "Verwenden Sie eine Schleife, um die Fibonacci-Folge in Python auszugeben.",
  bloomApplyExample3: "Lösen Sie ein reales Problem mithilfe einer Hashmap.",
  bloomUnderstandExample1:
    "Erklären Sie anhand des LIFO-Prinzips, wie ein Stack funktioniert.",
  bloomUnderstandExample2:
    "Beschreiben Sie den Unterschied zwischen var, let und const in JavaScript.",
  bloomUnderstandExample3:
    "Interpretieren Sie die Ausgabe der angegebenen SQL-Abfrage.",
  bloomRememberExample1:
    "Identifizieren Sie das richtige HTML-Tag, um einen Hyperlink zu erstellen.",
  bloomRememberExample2:
    "Nennen Sie die vier Säulen der objektorientierten Programmierung (OOP).",
  bloomRememberExample3: "Listen Sie die primitiven Datentypen in Java auf.",
  commonVerbs: "Häufige Verben",
  exampleQuestions: "Beispielfragen",
  noExamplesAvailable: "Keine Beispiele verfügbar.",
  candidateResponse: "Antwort des Kandidaten",
  correctQuestions: "Korrekte Fragen",
  totalQuestions: "Gesamtfragen",
  correctQuestionPercentage: "Prozentsatz korrekter Fragen",
  performance: "Leistung",
  level: "STUFE",
  noOfQuestions: "ANZAHL DER FRAGEN",
  correctAttempts: "KORREKTE VERSUCHE",
  correctness: "RICHTIGKEIT",
  partiallyCorrect: "TEILWEISE RICHTIG",
  partiallyCorrectPercentage: "PROZENTSATZ TEILWEISE RICHTIG",
  rescheduleAssessmentPrompt:
    "Bitte bestätigen Sie, ob Sie die Bewertung mit dem Titel „{{title}}“ verschieben möchten.",
  assessmentAlreadyStarted: "Bewertung hat bereits begonnen",
  readMore: "Mehr lesen",
  best: "Beliebt",
  latest: "Neueste",
  allQuestions: "Alle Fragen",
  myQuestions: "Meine Fragen",
  publicQuestions: "Öffentliche Fragen",
  remarks: "Bemerkungen",
  addRemarks: "Bemerkung hinzufügen",
  noGroupsAdded: "Noch keine Gruppen hinzugefügt",
  addGroupInfo:
    "Erstellen Sie zunächst eine Gruppe, um Fragen hinzuzufügen. Klicken Sie unten auf die Schaltfläche „Gruppe zu Abschnitt hinzufügen“, um zu beginnen.",
  exitPreview: "Vorschau beenden",
  preview: "Vorschau",
  problemStatementNotAdded: "Problembeschreibung nicht hinzugefügt",
  durationDayUnit: "Tag",
  durationDaysUnit: "Tage",
  durationHourUnit: "Std.",
  durationHoursUnit: "Std.",
  durationMinuteUnit: "Min.",
  customFieldAddedForSingleLanguage:
    "Benutzerdefiniertes Feld {{fieldLabel}} hinzugefügt für {{current}} von {{total}} Sprache",
  customFieldAddedForMultipleLanguages:
    "Benutzerdefiniertes Feld {{fieldLabel}} hinzugefügt für {{current}} von {{total}} Sprachen",
  email: "E-Mail",
  tagInputHint: "Durch Komma getrennt hinzufügen",
  enterOptions: "Optionen eingeben",
  groupNotFound: "Gruppe nicht gefunden",
  sheetNotFound: "Tabelle nicht gefunden",
  missingHeaders: "Erforderliche Spalten fehlen",
  assetNotFound: "Asset nicht gefunden",
  noValidDataFound: "Keine gültigen Daten gefunden",
  notFoundPID: "Teilnehmer nicht gefunden.",
  invalidParticipants: "Ungültiger Teilnehmer.",
  alreadyAdded: "Teilnehmer bereits hinzugefügt.",
  duplicateData: "Doppelte Daten gefunden.",
  invalidData: "Ungültige Daten.",
  warnings: "Warnungen",
  assignedToMyself: "Mir zugewiesen (Selbstgesteuertes Lernen)",
  assignedByMe: "Von mir zugewiesen (Meine Aufgaben)",
  urlCopiedToClipboard: "URL in die Zwischenablage kopiert!",
  failedToCopyUrl: "URL kopieren fehlgeschlagen.",
  content: "Inhalt",
  platformHelp: "Plattform-Hilfe",
  privacyPolicy: "Datenschutzerklärung",
  logout: "Abmelden",
  logoutConfirmTitle: "Möchten Sie sich wirklich abmelden?",
  logoutConfirmDescription:
    "Verlassen Sie uns schon? Sie können jederzeit zurückkommen und dort weitermachen, wo Sie aufgehört haben.",
  stayEngaged: "Weiter aktiv bleiben"
} as const;
export default de;
